import React, { useState } from 'react';
import { white, lightBlue } from './styles';

const Button = (props) => {
  const styles = {
    padding: '15px 20px',
    color: white,
    borderRadius: '15px',
    width: '7em',
    backgroundColor: props.color || lightBlue,
    textAlign: 'center',
    fontSize: 'large',
    cursor: 'pointer',
    transition: 'transform 0.3s ease',
  };

  const [hovered, setHovered] = useState(false);

  return (
    <div
      onClick={props.onClick}
      style={{ ...styles, margin: props.center ? 'auto' : 0 }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={hovered ? 'hvr-grow' : ''}
    >
      {props.text.toUpperCase()}
    </div>
  );
};

export default Button;
